<main class="c-main" role="main">
    <div class="c-page-incomingrequest">
        <div class="container u-pb30">
            <div class="row mobile--orange u-pt40">
                <div class="col-md-12">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a [routerLink]="['/']"> {{'IncomingPolicyRequestPortal.home' | translate}} </a></li>
                            <li class="breadcrumb-item active" aria-current="page"> &nbsp; - <span> {{ 'IncomingPolicyRequestPortal.location' | translate}}</span></li>
                        </ol>
                    </nav>
                    <h2 class="o-title"> {{'IncomingPolicyRequestPortal.title' | translate}} </h2>
                    <br>
                    <h4> {{'IncomingPolicyRequestPortal.subtitle' | translate}}</h4>
                </div>
            </div>
        </div>

        <div class="content-filter">
            <div class="content-filter__group">
                <span></span>
                <input class="o-form__input" (keyup.enter)="getallpolicyFilter()"  min="0"  type="number" style="background-color: white;" [(ngModel)]="requestF"   placeholder="{{'IncomingPolicyRequestPortal.placeholderID'| translate}}" numbersOnly>
                <div *ngIf="isNegative(requestF)" style="width:100%; background-color: #F2F0E9">
                    <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'IncomingPolicyRequestPortal.noNegativeNumber'| translate}}</mat-error></h5></span>
                </div>
            </div>

            <div class="content-filter__group">
                <span></span>
                <input  (input)="searchPerson($event)" style="background-color: white;" [(ngModel)]="searchPeopleRequestor" class="o-form__select" type="text" placeholder="{{'IncomingPolicyRequestPortal.placeholderRequestor'| translate}}" [matAutocomplete]="autoPersonBHP">
                <mat-autocomplete #autoPersonBHP="matAutocomplete">
                    <mat-option *ngFor="let option of peoples" [value]="option.fullName">
                        <div *ngIf="personFound" (click)="addpeopleMdmidFilterValue(option.mdmid)" >
                            <label mat-raised-button matTooltip="{{option.email}}" 
                            matTooltipPosition='right' matTooltipClass="primary-tooltip"
                            aria-label="Button that displays a tooltip in various positions">
                            {{option.fullName}}</label>
    
                        </div>
                        <div *ngIf="personNotFound">
                            {{'IncomingPolicyRequestPortal.notFound'| translate}}
                        </div>
    
                    </mat-option>
    
                </mat-autocomplete>
            </div>
            <div class="content-filter__group">
                <span></span>
                <select name="statusSelect" (change)="getallpolicyFilter()" [(ngModel)]="statusF" class="o-form__select" required> 
                    <option ngValue=''  >{{'IncomingPolicyRequestPortal.filterStatus'| translate}}</option>
                    <option  *ngFor="let status of statusSelect" [ngValue]="status.id">
                        <p *ngIf="status.name=='Pending'">{{'IncomingPolicyRequestPortal.statusPending'| translate}}</p>
                        <p *ngIf="status.name=='Approved'">{{'IncomingPolicyRequestPortal.statusApproved'| translate}}</p>    
                        <p *ngIf="status.name=='Reject'">{{'IncomingPolicyRequestPortal.statusReject'| translate}}</p>    
                        <p *ngIf="status.name=='Scaled'">{{'IncomingPolicyRequestPortal.statusScaled'| translate}}</p>     
                    </option>
                  </select>
            </div>

            <div class="content-filter__group">
                <span></span>
                <input  (input)="searchPersonModified($event)" style="background-color: white;" [(ngModel)]="searchPeopleModifiedby" class="o-form__select" type="text" placeholder="{{'IncomingPolicyRequestPortal.placeholderModifiedBy' | translate}}" [matAutocomplete]="autoPersonModBHP">
                <mat-autocomplete #autoPersonModBHP="matAutocomplete">
                    <mat-option *ngFor="let option of peoplesModified" [value]="option.fullName">
                        <div *ngIf="personFoundModif" (click)="addpeopleMdmidModifiedFilterValue(option.mdmid)" >
                            <label mat-raised-button matTooltip="{{option.email}}" 
                            matTooltipPosition='right' matTooltipClass="primary-tooltip"
                            aria-label="Button that displays a tooltip in various positions">
                            {{option.fullName}}</label>
    
                        </div>
                        <div *ngIf="personNotFoundModif">
                            {{'IncomingPolicyRequestPortal.notFound'| translate}}
                        </div>
    
                    </mat-option>
    
                </mat-autocomplete>
            </div>
        </div>

        <div class="container u-pb30">
            <div class="row">
                <div class="col-md-12">
                    <div class="c-search">
                        <tr>
                            <td>
                                <p style="padding: 10px;">
                                    <span class="table__mobile"> </span>
                                    <button class="btn btn--primary open_modal" (click)="clearFilter()" mat-raised-button>{{'IncomingPolicyRequestPortal.btnClearFilter'| translate}}</button>
                                </p>
                            </td>
                            <td>
                                <p>
                                    <span class="table__mobile"> </span>
                                    <button class="btn btn--primary open_modal" [disabled]="isNegative(requestF)" (click)="getallpolicyFilter()" mat-raised-button> {{'IncomingPolicyRequestPortal.btnApplyFilter'| translate}}</button>
                                </p>
                            </td>
                        </tr>
                    </div>
                    <table class="table table-bordered table-striped table-condensed">
                        <thead>
                            <tr>
                                <th>
                                    <p (click)="orderby('requestNumber', requestDesc)"> <span> {{'IncomingPolicyRequestPortal.colID' | translate}}</span>
                                        <i *ngIf="!requestDesc" style="cursor: pointer;" class="icon icon-arrow icon-arrow-down"></i>
                                        <i *ngIf="requestDesc" style="cursor: pointer; transform: rotate(90deg);" class="icon icon-arrow icon-arrow-down"></i>


                                    </p>

                                </th>
                                <th>
                                    <p> <span> {{'IncomingPolicyRequestPortal.colRequestor' | translate}}</span>
                                        <!--<i style="cursor: pointer;" class="icon icon-arrow icon-arrow-down"></i> -->


                                    </p>

                                </th>

                                <th>
                                    <p (click)="orderby('status', statusDesc)"><span>{{'IncomingPolicyRequestPortal.colStatus' | translate}}</span>
                                        <i *ngIf="!statusDesc" style="cursor: pointer;" class="icon icon-arrow icon-arrow-down"></i>
                                        <i *ngIf="statusDesc" style="cursor: pointer; transform: rotate(90deg);" class="icon icon-arrow icon-arrow-down"></i>

                                    </p>
                                </th>
                                <th>
                                    <p> <span>{{'IncomingPolicyRequestPortal.colCommentary' | translate}}</span>
                                        <!-- <i class="icon icon-arrow icon-arrow-down"></i> -->


                                    </p>

                                </th>
                                <th>
                                    <p><span>{{'IncomingPolicyRequestPortal.colModifiedBy' | translate}}</span>


                                    </p>
                                </th>

                                <th>
                                    <p><span>{{'IncomingPolicyRequestPortal.colObservations' | translate}}</span>
                                        <!-- <i class="icon icon-arrow icon-arrow-down"></i> -->

                                    </p>
                                </th>
                                <th>
                                    <p><span>{{'IncomingPolicyRequestPortal.colActions' | translate}}</span>
                                        <!-- <i class="icon icon-arrow icon-arrow-down"></i> -->

                                    </p>
                                </th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let seeApprovers of SeeApprovers">
                                <td class="table__title-row">
                                    <div align="center">
                                        <p> <strong> {{seeApprovers.policyId}} </strong></p>
                                    </div>
                                </td>

                                <td class="table__title-row">

                                    <p><strong class="table__mobile">{{'IncomingPolicyRequestPortal.colRequestor' | translate}}: </strong> <strong> {{seeApprovers.people.name}}</strong></p>
                                </td>

                                <td class="table__status">
                                    <div>
                                        <p> <strong class="table__mobile">{{'IncomingPolicyRequestPortal.colStatus' | translate}}: </strong>
                                            <i *ngIf="seeApprovers.status== 'Pending'" class="icon icon-more">  </i>
                                            <i *ngIf="seeApprovers.status== 'Scaled'" class="icon icon-arrow" style=" transform: rotateY(180deg);">  </i>
                                            <i *ngIf="seeApprovers.status=='Reject'" class="icon icon-close">  </i>
                                            <i *ngIf="seeApprovers.status=='Approved'" class="icon icon-check">  </i>

                                            <span *ngIf="seeApprovers.status=='Pending'">{{'IncomingPolicyRequestPortal.statusPending'| translate}} </span>
                                            <span *ngIf="seeApprovers.status=='Scaled'"> &nbsp;{{'IncomingPolicyRequestPortal.statusScaled'| translate}}  </span>
                                            <span *ngIf="seeApprovers.status=='Reject'">{{'IncomingPolicyRequestPortal.statusReject'| translate}} </span>
                                            <span *ngIf="seeApprovers.status=='Approved'">{{'IncomingPolicyRequestPortal.statusApproved'| translate}} </span>
                                        </p>
                                    </div>
                                </td>

                                <td>
                                    <p>{{seeApprovers.commentary}}</p>
                                </td>
                                <td>
                                    <span class="table__mobile" *ngIf="seeApprovers.lastModifiedName!=null">   
                                        {{'IncomingPolicyRequestPortal.colModifiedBy' | translate}}:
                                    </span> {{seeApprovers.lastModifiedName}}
                                </td>

                                <td style="text-align: center;">
                                    <a (click)="openDialogObs(seeApprovers)" style="cursor:pointer; margin: 10px">
                                        <img src="../assets/img/icn/ICONO/LUPA/BLANCA.svg" alt="">
                                    </a>
                                    <strong>
                                        <a  [routerLink]="['/policy/detail/','approved', seeApprovers.policyId ]" title="Request: {{ seeApprovers.policyId }}" style="cursor:pointer; margin: 10px"> 
                                            <img src="../assets/img/icn/ICONO/ARCHIVO.svg" alt="" >
                                        </a>
                                    </strong>
                                </td>
                                <td style="align-content:center;">
                                    <span class="table__mobile"></span>
                                    <div>
                                        <p title="{{'IncomingPolicyRequestPortal.btnEscalate'| translate}}" style="margin: 5px">
                                            <svg *ngIf="seeApprovers.status== 'Pending'" (click)="openDialogScale(seeApprovers)" style="cursor: pointer; color: #F67B2F;" width="30" height="30" viewBox="0 0 16 16" class="bi bi-pencil-square" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456l-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                                <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                                            </svg>
                                        </p>
                                        <p title="{{'IncomingPolicyRequestPortal.btnReject'| translate}}" style="margin: 5px">
                                            <svg *ngIf="seeApprovers.status== 'Pending' || seeApprovers.status== 'Scaled'" (click)="openDialogReject(seeApprovers)" style="cursor: pointer; color: #838A8E;" width="30" height="30" viewBox="0 0 16 16" class="bi bi-x-circle-fill" fill="currentColor"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                                            </svg>
                                        </p>
                                        <p title="{{'IncomingPolicyRequestPortal.btnAccept'| translate}}" style="margin: 5px">
                                            <svg *ngIf="seeApprovers.status== 'Pending' || seeApprovers.status== 'Scaled'" (click)="openDialogAccept(seeApprovers)" style="cursor: pointer; color: #01AB8B;" width="30" height="30" viewBox="0 0 16 16" class="bi bi-check-circle-fill" fill="currentColor"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                            </svg>
                                        </p>
                                    </div>
                                </td>
                            </tr>

                        </tbody>
                    </table>

                </div>
                <div class="col-md-12">
                    <hr class="big">
                    <div class="row pagination-main">
                        <div class="col-md-6">

                        </div>
                        <div class="col-md-6">
                            <ul class="pagination">

                                <mat-paginator #paginator [length]="totalItems" [pageSize]="pageSize" (page)="handlePage($event)" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 u-pt10" *ngIf="isPolicyRegionalApprover">
                    <button class="btn btn btn--primary" (click)="generateReport()">{{'IncomingPolicyRequestPortal.btnReport' | translate}}</button >
                </div>
            </div>
        </div>
    </div>
</main>